<template>
  <div class="content-guest-tabs" data-testid="content-guest-tabs">
    <Tabs
      v-if="commentsEnabled"
      id="content-guest-tabs"
      :selected-tab="selectedTab"
      @clicked="(e: any) => onTabClick(e.tab.hash)"
      @changed="(e: any) => onTabChange(e.tab.hash)"
    >
      <Tab id="comments" name="Comments" class="content-guest-tabs__tab">
        <div class="content-guest-tabs__comments">
          <Comments @addedComment="emit('addedComment')" />
        </div>
      </Tab>
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { Tab, Tabs } from '@/storybook';

import Comments from '@/modules/viewer/components/item_tabs/comments/Comments.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useTabNavigation } from '@/modules/viewer/composables/useTabNavigation';
import { useActiveTabListener } from '@/modules/viewer/composables/useActiveTab';

const emit = defineEmits<{
  addedComment: [];
}>();

const { commentsEnabled } = storeToRefs(useViewerItemStore());

const availableTabs = computed(() => {
  const tabs: string[] = [];
  if (commentsEnabled.value) {
    tabs.push('#comments');
  }
  return tabs;
});

const { selectedTab, onTabClick, onTabChange, selectTab } = useTabNavigation(availableTabs, '#comments');

// Listen for external tab switch requests (from EngagementBar)
const { activeTabOverride } = useActiveTabListener();
watch(activeTabOverride, tab => {
  if (tab) {
    selectTab(tab);
    activeTabOverride.value = null;
  }
});
</script>

<style scoped>
.content-guest-tabs {
  @apply mt-2 sm:mt-4;
}

.content-guest-tabs__tab {
  @apply mt-3 sm:mt-4;
}

.content-guest-tabs__comments {
  @apply relative flex flex-col p-3 sm:p-4 sm:border sm:border-slate-300 sm:dark:border-zinc-700 bg-white dark:bg-zinc-900 sm:rounded-10;
}
</style>
